import styled from 'styled-components';
import { StyledBaseWrapper } from '../styles';

export const StyledTrihowPadWrapper = styled(StyledBaseWrapper)`
  // TrihowPad-specific styles
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledTrihowPadHeader = styled.div`
  display: flex;
  gap: 8px;
  justify-content: space-between;
  align-items: center;
  padding-block: 16px;
  padding-inline: 16px;
  background-color: rgba(0, 0, 0, 0.25);
  position: relative;
  border-radius: 8px 8px 0 0;
`;
export const StyledTrihowPad = styled.div`
  // TrihowPad-specific styles
  display: flex;
  flex-direction: column;
  width: 80%;
`;

export const StyledTrihowPadContent = styled.div<{ maxSlidesPerGroup: number }>`
  background-color: #dddddd;
  padding: 80px 32px;
  position: relative;
  display: grid;
  place-items: center;
  border-radius: 0 0 8px 8px;
  grid-template-columns:
    repeat(${({ maxSlidesPerGroup }) => maxSlidesPerGroup - 1}, 1fr 7%)
    1fr;
`;

export const StyledTrihowPadSlideWrapper = styled.div<{ isFirst: boolean }>`
  display: grid;
  place-items: center;
  aspect-ratio: 1;
  width: 100%;
`;

export const StyledConnector = styled.div<{ isFirst: boolean }>`
  width: 70%;
  height: 2px;
  background-color: rgba(0, 0, 0, 0.25);
  display: ${({ isFirst }) => isFirst && 'none;'};
`;

export const StyledTrihowPadLogo = styled.div`
  background-color: #dddddd;
  padding: 12px;
  display: flex;
  gap: 4px;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
`;

export const StyledTrihowPadGroupNameInput = styled.input`
  background-color: transparent;
  border: none;
`;

export const StyledSplitScreenSlideWrapper = styled.div`
  display: grid;
  place-items: center;
  aspect-ratio: 1;
  flex: 1;
  padding: 16px;
`;
